import VStatus from '@/components/Barring/Status';

export default {
  components: {
    VStatus,
  },

  data() {
    return {
      isBlocked: null,
      isFactoringBarred: null,
      isResellingBarred: null,
      isVoiceFactoringBarred: null,
      items: null,
      isProfileTypeCategories: false,
    };
  },

  computed: {
    factoringItems() {
      return this.items.filter(item => item.type === 'factoring' && item.isBarred !== this.isFactoringBarred);
    },

    resellingItems() {
      return this.items.filter(item => item.type === 'reselling' && item.isBarred !== this.isResellingBarred);
    },

    voiceFactoringItems() {
      return this.items.filter(item => ['voiceFactoring', 'globalShortCode'].includes(item.type) && item.isBarred !== this.isVoiceFactoringBarred);
    },

    voiceFactoringExceptions() {
      return this.items.filter(item => item.type === 'voiceFactoring' && item.hasExceptions === true);
    },

    itemsWithoutExceptions() {
      return this.items.filter(item => item.hasExceptions === false && item.isBarred !== this.isFactoringBarred);
    },

    itemsWithExceptions() {
      return this.items.filter(item => item.hasExceptions === true);
    },

    hasVoiceFactoringExceptions() {
      const exceptions = this.voiceFactoringExceptions;
      return exceptions && exceptions.length > 0;
    },
  },

  methods: {
    parseResponse(response) {
      this.isBlocked = response.isBlocked;
      this.isFactoringBarred = response.isFactoringBarred;
      this.isResellingBarred = response.isResellingBarred;
      this.isVoiceFactoringBarred = response.isVoiceFactoringBarred;
      this.items = response.items;

      this.isProfileTypeCategories = response.isProfileTypeCategories;
    },
  },
};
